/**
 * API ordering values for list sorting.
 *
 * Applications and favorites sort by `create_date` (`NEWEST` / `OLDEST`).
 */
export enum ListSortOption {
    NEWEST = "-create_date",
    OLDEST = "create_date",
    MOST_EXPENSIVE = "-price",
    CHEAPEST = "price",
    BIGGEST = "-area",
    SMALLEST = "area"
}
/**
 * API ordering values for list sorting.
 *
 * Applications and favorites sort by `create_date` (`NEWEST` / `OLDEST`).
 */
export enum ListSortOption {
    NEWEST = "-create_date",
    OLDEST = "create_date",
    MOST_EXPENSIVE = "-price",
    CHEAPEST = "price",
    BIGGEST = "-area",
    SMALLEST = "area"
}
